import { configureStore } from "@reduxjs/toolkit";
import progressReducer from "../redux/progress/progressSlice";
import signReducer from "../redux/modal/signSlice";
import docPreviewReducer from "../redux/modal/docPreviewSlice";
import deleteReducer from "../redux/modal/deleteSlice";
import settingReducer from "../redux/modal/settingSlice";
import logoutReducer from "../redux/modal/logoutSlice";
import appsettingReducer from "../redux/appsettingSlice";
import filesReducer from "../redux/filesSlice";
import dashboardReducer from "../redux/dashboardSlice";

export const store = configureStore({
  reducer: {
    progress: progressReducer,
    signModal: signReducer,
    docPreviewModal: docPreviewReducer,
    deleteModal: deleteReducer,
    settingModal: settingReducer,
    logoutModal: logoutReducer,
    appsetting: appsettingReducer,
    files: filesReducer,
    dashboard: dashboardReducer,
  },
  devTools: true,
});
